import { render, staticRenderFns } from "./fbpDeclaration.vue?vue&type=template&id=51b22799"
import script from "./fbpDeclaration.vue?vue&type=script&lang=js"
export * from "./fbpDeclaration.vue?vue&type=script&lang=js"
import style0 from "./fbpDeclaration.vue?vue&type=style&index=0&id=51b22799&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports